import { AppConfig } from '../../models/config/app-config.type';

export const recaptchaSiteKeyFactory = (config: AppConfig): string =>
  config.recaptchaSiteKey;
